<template>
  <div class="search-container">
    <el-form
      ref="formInline"
      :inline="true"
      :model="formInline"
      class="demo-form-inline"
      label-width="100px"
      size="mini"
    >
      <el-form-item label="供应商名称" prop="supplierName">
        <el-select
          v-model="formInline.supplierName"
          multiple
          filterable
          default-first-option
          placeholder="请选择供应商名称"
        >
          <el-option
            v-for="(item, index) in supplierOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="供应商代码" prop="supplierCode">
        <el-input
          v-model="formInline.supplierCode"
          placeholder="请输入供应商代码"
        ></el-input>
      </el-form-item>
      <el-form-item label="GRN号码" prop="grnNumber">
        <el-input
          v-model="formInline.grnNumber"
          placeholder="请输入GRN号码"
        ></el-input>
      </el-form-item>
      <el-form-item label="匹配状态" prop="matchingState">
        <el-select
          v-model="formInline.matchingState"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in matchingStateOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="包码" prop="packageNum">
        <el-input
          v-model="formInline.packageNum"
          placeholder="请输入包码"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          icon="el-icon-search"
          type="primary"
          size="mini"
          @click="submitForm()"
        >
          查询
        </el-button>
        <el-button
          icon="el-icon-refresh"
          size="mini"
          @click="resetForm('formInline')"
        >
          重置
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "GrnSearch",
  data() {
    return {
      formInline: {
        supplierName: [],
        supplierCode: "",
        grnNumber: "",
        matchingState: "",
        packageNum: "",
      },
      supplierOptions: [],
      matchingStateOptions: [
        {
          value: "0",
          label: "未匹配",
        },
        {
          value: "1",
          label: "部分匹配",
        },
        {
          value: "2",
          label: "完全匹配",
        },
        {
          value: "-1",
          label: "匹配失败",
        },
      ],
    };
  },
  created() {
    this.fetchSupplierList();
    this.submitForm();
  },
  methods: {
    /**
     * @description 获取供应商名称
     */
    async fetchSupplierList() {
      const { userId } = this.$route.query;
      this.$api
        .post("/input/grn/supplierNameQuery", { userId: userId })
        .then((res) => {
          console.log("supplierOptions", res);
          this.supplierOptions = res.data;
        })
        .catch((err) => {
          console.log("err", err);
          this.$message.error(err.message);
        });
    },

    /**
     * @description 查询
     */
    submitForm() {
      console.log("保存的查询条件", this.formInline);

      this.$store.commit(
        "Grn/GRN_SEARCH_DATA",
        this.$baseLodash.cloneDeep(this.formInline)
      );
      this.$emit("childQuery", this.formInline);
    },

    /**
     * @description 重置
     */
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit("childQuery", this.formInline);
      this.$store.commit(
        "Grn/GRN_SEARCH_DATA",
        this.$baseLodash.cloneDeep(this.formInline)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.search-container {
  padding: 20px 20px 10px;
  background-color: #fff;
  border-radius: 4px;
  margin-bottom: 15px;
  // max-height: 100px;

  ::v-deep {
    .el-input__inner {
      width: 255px;
    }
    .el-select__tags {
      flex-wrap: unset;
      overflow: hidden;
    }
  }
}
</style>
